export class AppRegex {
  public static readonly PasswordRegex = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&].{8,}';
  public static readonly timingsRegex = '([0-9]{1,2}:[0-9]{2}[AP]{1}M-[0-9]{1,2}:[0-9]{2}[AP]{1}M)';
}
